import React, { Component } from "react";
import { connect } from "react-redux";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import { showHideModalCreate, guardarPlantilla } from "../actions";

class ModalCreate extends Component {
  modalContent = () => {
    const buttons = [];
    if (this.props.elementos.filter(x => x === "GsUuRYzK").count())
      buttons.push(
        <BoxButton
          key="ba[-1][0]"
          name="floppy-o"
          title="Guardar"
          disabled={this.props.saving}
        />
      );

    return (
      <form
        id="form"
        onSubmit={e => {
          e.preventDefault();
          this.props.guardarPlantilla();
        }}
        noValidate
      >
        <ButtonStrip actions={buttons} />
        <div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="control-label">Nombre</label>
                <Input
                  type="text"
                  reducer="plantillas"
                  path="modalCreate.data.nombre"
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label className="control-label">Tipo</label>
                <Input
                  type="select"
                  reducer="plantillas"
                  path="modalCreate.data.tipo"
                  options={[
                    { caption: "EMAIL", value: "EMAIL" },
                    { caption: "DOCUMENTO", value: "DOCUMENTO" }
                  ]}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label className="control-label">Plantilla</label>
                <Input
                  type="textarea"
                  reducer="plantillas"
                  path="modalCreate.data.texto"
                  rows={20}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { modalCreate } = this.props;

    return (
      <Modal
        ancho="70vw"
        mostrar={modalCreate.get("show")}
        contenido={this.modalContent()}
        titulo="Creacion/Modificacion de plantillas"
        nombre="modal_create_plantillas"
        onCerrarModal={() => this.props.showHideModalCreate(false)}
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalCreate: state.plantillas.get("modalCreate"),
    elementos: state.layout.get("elementos")
  };
};

const mapDispatchToProps = {
  showHideModalCreate,
  guardarPlantilla
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate);
